import PropTypes from "prop-types"

/**
 * PropTypes for CDRs SidebarSection component.
 *
 * @property {Object|null} selectedCdr - Currently selected CDR object (null if no selection)
 * @property {Object} filters - Current filter state
 * @property {Function} onFilterChange - Filter change dispatcher
 * @property {number} visibleCount - Number of CDRs after filtering
 */
export const cdrsSidebarSectionPropTypes = {
	selectedCdr: PropTypes.object,
	filters: PropTypes.object.isRequired,
	onFilterChange: PropTypes.func.isRequired,
	visibleCount: PropTypes.number.isRequired,
}

/**
 * PropTypes for Cdrs view.
 * No external props are expected; kept for consistency across view definitions.
 */
export const cdrsViewPropTypes = {}
